import DOMPurify from 'dompurify';

import Typography from '@mui/material/Typography';

import { HTMLTypographyType } from './type';

const decodeHtmlEntities = (text: string) => {
  const textArea = document.createElement('textarea');
  textArea.innerHTML = text;
  return textArea.value;
};

export default function TypographyHTML({
  content,
  line,
  sx,
  noMedia,
  ...rest
}: Readonly<HTMLTypographyType & { line?: number; noMedia?: boolean }>) {
  const decodedContent = decodeHtmlEntities(content);

  const purifyConfig = {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'src', 'class'],
    ...(noMedia && { FORBID_TAGS: ['img', 'video'] }),
  };

  const sanitizedContent = DOMPurify.sanitize(decodedContent, purifyConfig);

  const clampStyle = line
    ? {
        display: '-webkit-box',
        WebkitLineClamp: line,
        WebkitBoxOrient: 'vertical',
      }
    : {};

  return (
    <Typography
      component="div"
      sx={{
        // line 있으면 soft wrap(pre-wrap)으로 clamp가 동작; 없으면 기존 pre 유지
        whiteSpace: line ? 'pre-wrap' : 'pre',
        overflow: line ? 'hidden' : 'auto',
        ...(clampStyle as object),
        ...(sx as object),
      }}
      {...rest}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
}
